<template>
  <div>
    <Head title="Sorting" />
    <h1 class="mb-8 text-3xl font-bold">Sorting</h1>
    <!--
    <div class="bg-white rounded-md shadow overflow-hidden mb-1">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pl-8 pr-8">
          <text-input
            v-model="form.item_id"
            :error="form.errors.item_id"
            class="pb-2 pr-6 w-full lg:w-1/2"
            placeholder="Scan UID"
            @keyup="checkUID"
          />
          <text-input
            v-model="form.quantity"
            :error="form.errors.quantity"
            class="pb-2 pr-6 w-full lg:w-1/2"
            placeholder="Quantity"
          />
        </div>
        <div v-if="itemObj.name" class="pl-8 pr-8 pb-2">
          <div class="p-2 alert alert-success ">
            <div>Part Number: {{ itemObj.sku }}</div>
            <div>Description: {{ itemObj.description }}</div>
          </div>
        </div>
        <div
          v-else
          class="p-7"
        >
          <div v-if="msgStr" class="text-orange-50 px-6 py-4 border-0 rounded relative mb-4 bg-orange-500">
            <span class="text-xl inline-block mr-5 align-middle">
              <i class="fas fa-bell" />
            </span>
            <span class="inline-block align-middle mr-8">
              {{ msgStr }}
            </span>
            <button class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none">
              <span>×</span>
            </button>
          </div>
        </div>
        <div
          v-if="itemObj.name"
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button
            :loading="form.processing"
            class="btn-orange px-3 py-2 text-xs"
            type="submit"
          >
            Add Receipts
          </loading-button>
        </div>
      </form>
    </div>
  -->

    <div class="flex items-center justify-between mb-1 mt-2">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link class="btn-orange" href="">
        <span>Add</span>
        <span class="hidden md:inline">&nbsp;Receipt</span>
      </Link>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Item UID</th>
          <th class="pb-3 pt-3 px-3">Part No.</th>
          <th class="pb-3 pt-3 px-3">Description</th>
          <th class="pb-3 pt-3 px-3">Quantity</th>
          <th class="pb-3 pt-3 px-3" colspan="2">UoM</th>
        </tr>
        <tr v-for="item in receipts.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ item.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.item_id }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.sku_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.quantity }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.unit_of_measure }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link v-if="item.components.length === 0" class="flex items-center px-3" :href="`/sorting-receipts/${item.id}/create`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
            <Link v-else class="flex items-center px-3" :href="`/sorting-receipts/${item.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="receipts.data.length === 0">
          <td class="px-2 py-2 border-t" colspan="7">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="receipts.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
// import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
// import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
//import SearchFilterRight from '@/Shared/SearchFilterRight'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
// import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import axios from 'axios'

export default {
  components: {
    Head,
    Icon,
    Link,
    //SearchFilterRight,
    SearchFilter,
    TextInput,
    //SelectInput,
    LoadingButton,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    receipts: Object,
    locations: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        search: this.filters.search,
        item_id: null,
        quantity: null,
        adjusted_quantity: null,
      }),
      measurePcs: 'PCS',
      itemObj: [],
      msgStr: '',
    }
  },
  computed: {
    confirmItem() {
      return this.itemObj || []
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    store() {
      if (this.msgStr === '') {
        this.form.post('/sort-receipts')
        this.form.item_id = ''
        this.form.quantity = ''
        this.itemObj = []
      }
    },
    checkUID() {
      if (this.form.item_id) {
        axios.get(`/sorting-receipt-items/${this.form.item_id}/search`).then(response => {
          if (response.data.message === '') {
            this.itemObj = response.data
            this.form.quantity = response.data.quantity
            this.msgStr = ''
          } else {
            this.itemObj = []
            this.msgStr = response.data.message
          }
        })
      } else {
        this.msgStr = ''
      }
    },
  },
}
</script>
